(function (Drupal, $, once) {
  Drupal.behaviors.card_view_listing = {
    attach: function (context) {
      $(function() {

        $(once("card-view-listing-init", ".card-view-listing")).each(function() {
          $(this).closest('.card-view-listing__wrapper').show();
          var intro = $(this).find('.card-view-listing__intro >p:first-of-type');
          var intro_height = intro.height();

          if($(window).width() < 1024) {
            let i = 0;
            while (intro_height > 100 && i < 20) { // 4 lines crop
              intro.text(intro.text().split("").slice(0, -3).join("") + "…");
              intro_height = intro.parent().height();
              i++;
            }
          }
          else {
            let i = 0;
            while (intro_height > 50 && i < 20) { // 2 lines crop
              intro.text(intro.text().split("").slice(0, -3).join("") + "…");
              intro_height = intro.parent().height();
              i++;
            }
          }


        });

        $(once('card-view-listing-wrapper-init', '.card-view-listing__wrapper')).each(function(index) {
          var $this = $(this);

          if($this.hasClass('search-result-card')) {
            var title = $this.find('.card-view-listing__title >a').text();
            var url = $this.find('.card-view-listing__title >a').attr('href');
            $this.find('.card-view-listing__title >a').remove();
            $this.find('.card-view-listing__title').text(title);
            $this.children('.card-view-listing').wrapInner("<a href='"+url+"'></a>")
          }

          setTimeout(function() {
            $this.css({
              'opacity': '1',
              'visibility': 'visible',
              'transform': 'translateX(0)'
            });
          }, 125*index);
        });
      });
    }
  }
})(Drupal, jQuery, once);
